module.exports = ".itpx-heading {\n    border-radius: 2px;\n    padding: 16px;\n    margin-bottom: 16px;\n    border: solid 1px #eee;\n    border-left: solid 4px #38B6A0 !important;\n}\n\n.itpx-heading > p,\n.itpx-heading > h2 {\n    margin-top: 0;\n    margin-bottom: 0;\n}\n\n.header {\n    margin-bottom: 0;\n    color: #38B6A0;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/components/happy/happy-heading/happy-heading.component.css
// module id = ./src/app/shared/components/happy/happy-heading/happy-heading.component.css
// module chunks = main